import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createPipelineQuery } from '../apis';
import queryKeys from '../constants/queryKeys';

// POST /api/pipelines. Deliberately does NOT toast on error and does NOT swallow the
// rejection — the wizard's Name step (AC-7) must show the 400 (1:1 conflict / validation,
// RV-3) INLINE without advancing and without losing the entered name, so the caller uses
// `mutateAsync(...).catch(...)` to read the error itself.
const useCreatePipeline = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPipelineQuery,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.getList() });
    },
  });
};

export default useCreatePipeline;
